/**
 * @fileoverview Barrel exports for the character-snapshotter-v2 composite agent.
 *
 * This composite orchestrates entity detection followed by parallel
 * per-character snapshot generation:
 * - chapter-entity-detector-v2: Detects present characters
 * - character-snapshotter-single-v2: Generates snapshot per character (×N parallel)
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  SnapshotResultSchema,
  CharacterContextEntrySchema,
  type Input,
  type Output,
  type SnapshotResult,
} from './schema';

// Flow
export { flow, characterSnapshotterV2AgentFlow } from './flow';

